import { render } from "./App.vue?vue&type=template&id=1969e6eb"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1969e6eb&lang=css"

import exportComponent from "/home/hadams/code/Vuejs_Wordle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__